import { get, post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>
// type ApiBasePageResult<T> = ApiTypes.ApiBasePageResult<T>

export namespace tag {
  export function getTagGroupList(data: PostData.Tag.TagGroupModel) {
    return get<ApiBaseResult<ServerData.Tag.TagGroupData[]>>('/tag/search', { ...data })
  }

  export function addTagGroup(data: PostData.Tag.AddTagGroupModel) {
    return post<ApiBaseResult<number>>('/tag_group/add', {}, { ...data })
  }

  export function delTagGroup(data: PostData.Tag.DeleteTagGroupModel) {
    return post<ApiBaseResult<null>>('/tag_group/delete', {}, { ...data })
  }

  export function addTag(data: PostData.Tag.AddTagModel) {
    return post<ApiBaseResult<{ tagId: number }>>('/tag/add', {}, { ...data })
  }

  export function delTag(data: PostData.Tag.DelTagModel) {
    return post<ApiBaseResult<null>>('/tag/delete', {}, { ...data })
  }

  export function updTag(data: PostData.Tag.UpdTagModel) {
    return post<ApiBaseResult<null>>('/tag/update', {}, { ...data })
  }

  export function updateTagGroup(data: PostData.Tag.UpdTagGroupModel) {
    return post<ApiBaseResult<{ tagGroupId: number }>>('/tag_group/update', {}, { ...data })
  }
}
